import React from 'react';
import styled from 'styled-components';
import { BG } from '../../styles/color';

const Best = styled.p`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${(props) => (props.size === 'large' ? '90px' : '60px')};
	height: ${(props) => (props.size === 'large' ? '32px' : '24px')};
	margin: 0;
	text-align: center;
	font-family: Pretendard Variable;
	font-weight: 380;
	font-size: ${(props) => (props.size === 'large' ? '20px' : '14px')};
	background-color: ${BG.light02};
	border-radius: 5px;
	box-sizing: border-box;
`;

export default function BestFlag(props) {
  	return (
		<Best size={ props.size } style={ props.style }>베스트</Best>
  	);
}